import script from "./StoreAdminServices.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminServices.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminServices.vue?vue&type=style&index=0&id=480d25c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-480d25c6"]])

export default __exports__